import axios from 'axios';

axios.defaults.baseURL = `http://aovivo.live4jesus.com.br/`;
// axios.defaults.baseURL = `http://127.0.0.1:8000/`;

export default axios;